export default function InvoiceReducer(state = { invoiceList: [], systemSettings: null, invoiceSearchFilters: {}, defaultStorages: {}, taxPayerInvoices: { Data: [], TotalCount: 0, taxPayerSearchFilters: {} } }, action) {
    switch (action.type) {
        case "SEARCH_INVOICE":
            return {
                ...state,
                invoiceList: action.data
            }
        case "GET_SYSTEM_SETTINGS":
            return {
                ...state,
                systemSettings: action.data
            }
        case "INVOICE_SEARCH_FILTERS":
            return {
                ...state,
                invoiceSearchFilters: action.data
            }
        case "DEFAULT_STORAGES":
            return {
                ...state,
                defaultStorages: action.data
            }
        case "SEARCH_TAXPAYER_INVOICE":
            return {
                ...state,
                taxPayerInvoices: action.data
            }
        case "TAXPAYER_SEARCH_FILTERS":
            return {
                ...state,
                taxPayerSearchFilters: action.data
            }
        case "GET_DISASSEMBLY_LIST":
            return {
                ...state,
                disassemblySearchList: action.data
            }
        case "DISASSEMBLY_SEARCH_FILTERS":
            return {
                ...state,
                disassemblySearchFilters: action.data
            }
        default:
            return state;

    }
}